// Background images & intrinsic pixel sizes
// NEW_MAP.jpg is 3840x2507, the same shape as the map below, so it is drawn at
// 0.75 both ways. (It was 3840x2800, which squashed the art to 0.67 vertically
// while the buildings kept their shape, so no position fitted both the art and
// the other buildings.) `?v=2` stops browsers from reusing the old picture.
export const DESKTOP_BG = "/assets/images/NEW_MAP.jpg?v=2";
export const MOBILE_BG = "/assets/images/NEW_MAP.jpg?v=2"; // Use same image for mobile since mobile version doesn't exist

// Size of the map in world units; building x/y in mapData.ts are in these units.
export const DESKTOP_IMAGE_SIZE = { w: 2880, h: 1880 };
export const MOBILE_IMAGE_SIZE = { w: 2880, h: 1880 };

// Zoom constraints
export const MAX_ZOOM = 3.0; // Increased for better mobile experience
export const ZOOM_STEP = 0.1;
export const MOBILE_ZOOM_SENSITIVITY = 0.005; // Sensitivity for pinch zoom
